import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormGroup,
  // FormControlLabel,
  // Switch,
} from '@mui/material';
import './table.scss';
import { IconEdit, IconView } from '../../../icons/Icon';
import { useNavigate } from "react-router-dom";
import { dateFormatStandard } from '../../../utils/format';

interface UsersTabledata {
  users: any;
}
const UserConfigurationTable: React.FC<UsersTabledata> = ({ users }): JSX.Element => {
  const navigate = useNavigate();
  return (
    <FormGroup className="table-wrapper RbacTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 422 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>User Id</TableCell>
              <TableCell>Email Id</TableCell>
              <TableCell>User Name</TableCell>
              <TableCell>User Role</TableCell>
              <TableCell>Last Login</TableCell>
              <TableCell>Is Active</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.length !== 0 ? (
                users.map((data:any, index:any) => (
                  <TableRow key={index}>
                    <TableCell>{data?.userid}</TableCell>
                    <TableCell>{data?.emailid}</TableCell>
                    <TableCell>{data?.username}</TableCell>
                    <TableCell>{data?.userrole}</TableCell>
                    <TableCell>{data?.lastlogin ? dateFormatStandard(data?.lastlogin) : ""}</TableCell>
                    <TableCell>{data?.isactive}</TableCell>
                    <TableCell>
                      <div className='flex aligns-items-center'>
                        <button className='ml-10' title='Edit' onClick={() => navigate(`/userconfiguration/edit/${data?.userid}`)}>
                          <IconEdit />
                        </button>
                        <button className='ml-10 view' title='View' onClick={() => navigate(`/userconfiguration/view/${data?.userid}`)} >
                          <IconView />
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} className='grey-bg center'>No data found</TableCell>
                </TableRow>
              )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </FormGroup>
  );
};

export default UserConfigurationTable;
